import { redirect } from '@tanstack/react-router'
import {
  getCurrentUser,
  waitForAuthReady,
} from '@zealth/core/firebase/authStore'

// Route guard for authenticated-only routes. Waits for Firebase boot,
// then redirects unauthenticated visitors to the sign-in flow.
export const requireAuth = async (): Promise<void> => {
  await waitForAuthReady()
  if (!getCurrentUser()) {
    throw redirect({ to: '/signin' })
  }
}

// Route guard for guest-only routes (sign-in, landing). Waits for Firebase
// boot, then redirects already-authenticated visitors to the dashboard.
export const requireGuest = async (): Promise<void> => {
  await waitForAuthReady()
  if (getCurrentUser()) {
    throw redirect({ to: '/dashboard' })
  }
}
